import React, { useState } from 'react';
import { Button, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

import { GuideMessageBar } from '../../../../theme/components/GuideMessageBar';
import { describeReviewWarning } from '../ContractReview.Functions';
import { useFieldLabel, useHumanizeText } from '../ContractReview.Text';

// Avisos del servicio de IA en un solo banner, en lenguaje de usuario: qué pasó y qué significa; el texto original a pedido.

export interface ContractReviewWarningsProps {
  warnings: string[];
}

export const ContractReviewWarnings: React.FC<ContractReviewWarningsProps> = ({ warnings }) => {
  const { t } = useTranslation();
  const [showRaw, setShowRaw] = useState(false);
  const fieldLabel = useFieldLabel();
  const humanize = useHumanizeText();
  if (warnings.length === 0) return null;

  const infos = warnings.map(describeReviewWarning);
  const anyKnown = infos.some(info => info.kind !== 'other');

  return (
    <section className="crv-notices" aria-label={t('contractReview.page.warnings')} data-testid="review-warnings">
      <GuideMessageBar intent="warning" layout="multiline">
        <MessageBarBody>
          <MessageBarTitle>{t('contractReview.warnings.title')}</MessageBarTitle>
          <ul className="crv-notices__list">
            {infos.map((info, index) => {
              const known = info.kind !== 'other';
              // El aviso de enumerado nombra el campo del modelo: va en palabras.
              const params = info.kind === 'unknownEnum' ? { ...info.params, field: fieldLabel(String(info.params.field)) } : info.params;
              return (
                <li key={index} data-testid={`review-warning-${info.kind}`}>
                  <span className="crv-notice__title">{known ? t(`contractReview.warnings.${info.kind}.title`, params) : t('contractReview.warnings.other.title')}</span>
                  <span className="crv-notice__text">{known ? t(`contractReview.warnings.${info.kind}.text`, params) : humanize(info.raw)}</span>
                  {known && showRaw && <span className="crv-notice__raw">{info.raw}</span>}
                </li>
              );
            })}
          </ul>
          {anyKnown && (
            <Button appearance="transparent" size="small" onClick={() => setShowRaw(v => !v)} data-testid="review-warnings-raw">
              {showRaw ? t('contractReview.warnings.hideRaw') : t('contractReview.warnings.showRaw')}
            </Button>
          )}
        </MessageBarBody>
      </GuideMessageBar>
    </section>
  );
};

export default ContractReviewWarnings;
